import React from 'react';
import PropTypes from 'prop-types';
import { useSite } from '@edreamsodigeo/frontend-core';
import { Body, Box, DateTime } from '@edreamsodigeo/prisma-design-system';

export const PriceFreezeDate = ({
  type = 'date',
  pattern,
  date,
  format = 'EEE, dd/MM',
}) => {
  const dateFormatWorld = {
    EEEddMM: 'EEE, dd/MM',
    ddMMMM: 'dd MMMM',
    ddMMMMHHmm: 'dd MMMM, HH:mm',
    ddMMMHH: 'dd/MM/YYY',
    HHmm: 'HH:mm',
  };
  const dateFormatUS = {
    EEEddMM: 'EEE, MM/dd',
    ddMMMM: 'MMMM dd',
    ddMMMMHHmm: 'MMMM dd, HH:mm',
    ddMMMHH: 'MM/dd/YYY',
    HHmm: 'HH:mm',
  };
  const site = useSite();
  const dateFormat = site === 'US' ? dateFormatUS : dateFormatWorld;

  return (
    <DateTime
      type={type}
      pattern={pattern}
      format={dateFormat[format]}
      value={date}
    />
  );
};

export const PriceFreezeTime = ({
  type = 'time',
  pattern = 'short',
  date,
  format = 'HH:mm',
  daysDiff = 0,
}) => {
  return (
    <Box position="relative">
      <DateTime type={type} pattern={pattern} format={format} value={date} />
      {daysDiff > 0 && (
        <Box position="absolute" sx={{ top: '-8px', right: '-12px' }}>
          <Body type="xSmall" color="neutral.90">
            +{daysDiff}
          </Body>
        </Box>
      )}
    </Box>
  );
};

PriceFreezeDate.propTypes = {
  date: PropTypes.string.isRequired,
};
PriceFreezeTime.propTypes = {
  date: PropTypes.string.isRequired,
};
